import { StMaskedInput } from './Input.styled'

import type { MaskedInputProps } from 'react-text-mask'

export const MaskedInput = ({ ...props }: MaskedInputProps) => {
  return <StMaskedInput {...props} />
}
